<template>
  <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="900px" append-to-body
    :destroy-on-close="true" :before-close="cancel">
    <div class="detail-grid" style="grid-template-columns: 1fr 1fr 1fr;">
      <template v-for="(info, index) in data.filter(item => item.label === selectDetail)">
        <div class="detail-item" :key="'label-' + index">
          <span class="detail-label">阶段</span>
          <span class="detail-value">{{ info.label }}</span>
        </div>
        <div class="detail-item" :key="'status-' + index">
          <span class="detail-label">状态</span>
          <span class="detail-value">{{ info.name }}</span>
        </div>
        <div class="detail-item" :key="'desc-' + index">
          <span class="detail-label">说明</span>
          <span class="detail-value">{{ info.description }}</span>
        </div>
      </template>
      <template v-if="selectDetail === '原始数据'">
        <div class="detail-item full-width">
          <span class="detail-label">释放结果说明</span>
          <span class="detail-value">纯分析和其他项目（项目模块为其他，如荧光定量）为释放分析结果，测序分析/裸测为释放原始数据</span>
        </div>
      </template>
    </div>
  </el-dialog>
</template>

<script>


import Template from "@/views/systems/Template/Template.vue";

export default {
  name: "StatusInfo",
  components: {Template},
  props: ['showDialog', 'selectDetail'],
  data() {
    return {
      title:'查看合同各阶段状态说明',
      data:[
        {label: '合同审核',  name: '已通过',description:'合同已通过审核'},
        {label: '合同审核',  name: '待审核',description:'合同已提交，但还未通过审核'},
        // {label: '合同审核',  name: '待评估',description:'合同为纯分析合同，正在等待评估人评估，通过后进入待审核状态，未通过进入已驳回状态'},
        {label: '合同审核',  name: '已驳回',description:'合同未通过评估或未通过审核'},
        {label: '合同审核',  name: '已终止', description: '合同已终止'},

        {label: '扣款状态',  name: '未扣款',description:'合同未通过审核或未通过评估，正在等待处理'},
        {label: '扣款状态',  name: '已扣款',description:'合同通过审核，已扣除客户合同金额'},

        {label: '资料邮寄/扫描',  name: '未申请',description:'合同还未申请过资料邮寄'},
        {label: '资料邮寄/扫描',  name: '已提交',description:'资料邮寄申请已提交'},
        {label: '资料邮寄/扫描',  name: '已邮寄',description:'资料已邮寄，可查看快递单号信息'},
        {label: '资料邮寄/扫描',  name: '已取消',description:'邮寄申请已取消'},

        {label: '发票开具',  name: '未申请',description:'合同还未进行申请开票'},
        {label: '发票开具',  name: '未开票',description:'合同开票申请已提交，商务专员还未开票'},
        {label: '发票开具',  name: '部分开票',description:'商务专员已对开票申请中部分申请开票完毕'},
        {label: '发票开具',  name: '全部开票',description:'商务专员已对开票申请中全部申请开票完毕'},

        {label: '项目到款',  name: '未到款',description:'合同所开发票的金额还未到款'},
        {label: '项目到款',  name: '部分到款',description:'合同所开发票已到款部分金额'},
        {label: '项目到款',  name: '已到款',description:'合同所开发票金额已全部到款'},
        {label: '项目到款',  name: '未开票',description:'商务专员还未进行开票操作'},

        {label: '原始数据',  name: 'NA',description:'该合同在项目管理系统不存在'},
        {label: '原始数据',  name: '未释放',description:'该合同下所有项目均未释放结果'},
        {label: '原始数据',  name: '部分释放',description:'该合同下部分项目释放结果'},
        {label: '原始数据',  name: '已释放',description:'该合同下所有项目均已释放结果'},

        {label: '管理系统收样',  name: '未收样', description: '项目管理系统未完成该合同项目收样'},
        {label: '管理系统收样',  name: '已收样', description: '项目管理系统已完成该合同项目收样'},
      ]
    }
  },
  mounted() {
    this.title = '查看合同' + this.selectDetail + '阶段状态说明'
  },
  methods: {
    cancel() {
      this.$emit('submit', 'cancel')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/detail.css";
</style>
